import { useEffect, type RefObject } from 'react';

interface UsePopoverDismissalInput {
  anchorElement: HTMLElement | null;
  dismissOnOutsideClick: boolean;
  onClose?: () => void;
  popoverRef: RefObject<HTMLDivElement | null>;
  visible: boolean;
}

function shouldDismissForPointerDown(input: {
  anchorElement: HTMLElement | null;
  popoverElement: HTMLDivElement | null;
  target: EventTarget | null;
}): boolean {
  if (!(input.target instanceof Node)) {
    return false;
  }

  if (input.popoverElement?.contains(input.target)) {
    return false;
  }

  if (input.anchorElement?.contains(input.target)) {
    return false;
  }

  return true;
}

export function usePopoverDismissal({
  anchorElement,
  dismissOnOutsideClick,
  onClose,
  popoverRef,
  visible,
}: UsePopoverDismissalInput): void {
  useEffect(() => {
    if (!visible || !dismissOnOutsideClick || !onClose) {
      return;
    }

    const handlePointerDown = (event: MouseEvent): void => {
      if (
        shouldDismissForPointerDown({
          anchorElement,
          popoverElement: popoverRef.current,
          target: event.target,
        })
      ) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handlePointerDown, true);

    return () => {
      document.removeEventListener('mousedown', handlePointerDown, true);
    };
  }, [anchorElement, dismissOnOutsideClick, onClose, popoverRef, visible]);
}
